import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import { MainWrapper, CloseCircleBlock } from './switcher.styled';

const Switcher = props => {
  return (
    <MainWrapper>
      <CloseCircleBlock onClick={props.onClickAction}>
        <Icon name='switcher' colorPath='#ffffff' size='large' />
      </CloseCircleBlock>
    </MainWrapper>
  );
};

Switcher.propTypes = {
  onClickAction: PropTypes.func,
};

export default Switcher;
